import { Card } from '@/scopes/common/components/Card'
import { mqMin, tokPx } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export const AccoCardContainer = styled(Card)`
  display: flex;
  flex-direction: row;
  text-decoration: none;

  &:hover {
    color: inherit;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    width: 320px;
    flex-direction: column;
  }
`

export const CardMain = styled.div`
  padding: ${tokPx('primitives_space_12')};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${tokPx('primitives_space_16')};
  }
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${tokPx('primitives_space_12')};
  gap: ${tokPx('primitives_space_8')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    margin-bottom: ${tokPx('primitives_space_16')};
  }
`

export const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`
